const exp = (t: number) => 1 / (1 + t + 0.48 * t * t + 0.235 * t * t * t);

const damp = (
  current,
  prop,
  target,
  smoothTime = 0.25,
  delta = 0.01,
  maxSpeed = Infinity,
  easing = exp,
  eps = 0.001,
) => {
  const vel = "velocity_" + prop;
  if (current.__damp === undefined) current.__damp = {};
  if (current.__damp[vel] === undefined) current.__damp[vel] = 0;

  if (Math.abs(current[prop] - target) <= eps) {
    current[prop] = target;
    return false;
  }

  smoothTime = Math.max(0.0001, smoothTime);
  const omega = 2 / smoothTime;
  const t = easing(omega * delta);
  let change = current[prop] - target;
  const originalTo = target;
  // Clamp maximum maxSpeed
  const maxChange = maxSpeed * smoothTime;
  change = Math.min(Math.max(change, -maxChange), maxChange);
  target = current[prop] - change;
  const temp = (current.__damp[vel] + omega * change) * delta;
  current.__damp[vel] = (current.__damp[vel] - omega * temp) * t;
  let output = target + (change + temp) * t;
  // Prevent overshooting
  if (originalTo - current[prop] > 0.0 === output > originalTo) {
    output = originalTo;
    current.__damp[vel] = (output - originalTo) / delta;
  }
  current[prop] = output;
  return true;
};

const easeOutBack = (x: number): number => {
  const c1 = 1.70158;
  const c3 = c1 + 1;

  return 1 + c3 * Math.pow(x - 1, 3) + c1 * Math.pow(x - 1, 2);
};

const easeOutExpo = (x: number): number => {
  return x === 1 ? 1 : 1 - Math.pow(2, -10 * x);
};

const easeInExpo = (x: number): number => {
  return x === 0 ? 0 : Math.pow(2, 10 * x - 10);
};

const lerp = (start, end, amt) => {
  return (1 - amt) * start + amt * end;
};
const clamp = (num, min, max) => Math.min(Math.max(num, min), max);
const map = (a, b, c, d, x) => ((x - a) * (d - c)) / (b - a) + c;

export { clamp, damp, easeInExpo, easeOutBack, easeOutExpo, exp, lerp, map };
